import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import CardHeader from "@commons/businesscardHeader";
import Column from "@components/column";
import Fields from "@components/fields";
import Row from "@components/row";
import Wrapper from "@components/wrapper";
import { toast } from "react-toastify";
import generalSettings from "@apis/generalSettings";
import Button from "@components/button";
import { m } from "framer-motion";
import { GeneralSetting } from "@apis/index";

const Esewa = () => {
  const [initialValues, setInitialValues] = useState({
    title: "",
    esewaQr: null,
  });
  const [existing, setExisting] = useState(null);
  const [loading, setLoading] = useState(false);
  const [infoFields, setInfoFields] = useState([]);

  const fetchEsewaSettings = async () => {
    await generalSettings
      .getByKey({
        state: "esewa",
        id: "esewa",
      })
      .then((res) => {
        console.log({ res });
        const parsed = res?.infos ?? {};

        // Extract all keys from infos (ignore status)
        const infoKeys = Object.keys(parsed).filter((key) => key !== "status");
        setInfoFields(infoKeys);

        // Create initial values dynamically
        const dynamicValues = {};
        infoKeys.forEach((key) => {
          dynamicValues[key] = parsed[key] || "";
        });

        setInitialValues({
          ...dynamicValues,
          title: res.title || "",
          esewaQr: res.file || null,
        });
        setExisting(res);
      });
  };

  useEffect(() => {
    fetchEsewaSettings();
  }, []);

  const handleSubmit = async (values: any) => {
    console.log(values);
    setLoading(true);
    const formData = new FormData();
    try {
      formData.append("group", "payment-settings");
      formData.append("key", "esewa");
      formData.append("title", values.title);

      const infos = {};
      infoFields.forEach((field) => {
        infos[field] = values[field];
      });

      formData.append("infos", JSON.stringify(infos));

      if (values?.esewaQr?.rawFile) {
        formData.append("file", values.esewaQr.rawFile);
      }
      if (existing?.id) {
        await GeneralSetting.update({
          state: "esewa",
          data: formData,
          id: existing?.id,
        }).then(() => {
          toast.success("Updated");
          fetchEsewaSettings();
        });
      } else {
        await GeneralSetting.create({ state: "esewa", data: formData }).then(() => {
          toast.success("Created");
          fetchEsewaSettings();
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to update Esewa settings");
    } finally {
      setLoading(false);
    }
  };

  const formatLabel = (key) => {
    return key
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase())
      .trim();
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <CardHeader title="Esewa" />
          <Wrapper>
            <Row styleRow="align-items:start;gap:20px">
              <div style={{ flex: 2, width: "100%" }}>
                <Column>
                  <Fields.Input
                    name="title"
                    label="Payment Gateway Title*"
                    placeholder="Type here"
                  />

                  {infoFields.map((fieldName) => (
                    <Fields.Input
                      key={fieldName}
                      name={fieldName}
                      label={`${formatLabel(fieldName)}*`}
                      placeholder="Type here"
                    />
                  ))}
                </Column>
              </div>
              <div style={{ flex: 1, width: "100%" }}>
                <Fields.Upload name="esewaQr" useRawFile={true} />
              </div>
            </Row>

            <div style={{ marginTop: 16, textAlign: "right" }}>
              <Button
                title={existing?.id ? "Update" : "Save"}
                type="submit"
                loading={loading}
                justify="end"
              />
            </div>
          </Wrapper>
        </Form>
      )}
    </Formik>
  );
};

export default Esewa;
